import styled from '@emotion/styled'

const withStyle = (Row) =>
  styled(Row)((props) => {
    const gutter = 12
    return `
        && {
          width: ${props.type === 'full' ? `calc(100% - ${gutter}px)` : 'auto'};
        }
      `
  })

export default withStyle
